export const GERAR_ARQUIVO_WHATSAPP_ACTION = '@gerarArquivoWhatsapp/GERAR_ARQUIVO_WHATSAPP_ACTION';
